@use '@design/design-tokens/typography/typography' as *;

.proportionChangeColumn {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-end;
}

.priceRow {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.proportionPrice {
  font-family: var(--font-roboto-mono);
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: var(--text-default);
}

.proportionCurrency {
  @include typography-v2-body-xxs;

  color: var(--text-default);
  text-transform: uppercase;
}

.percentageChange {
  font-family: var(--font-roboto-mono);
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;

  &.positive {
    color: var(--viz-bullish);
  }

  &.negative {
    color: var(--viz-bearish);
  }

  &.default {
    color: var(--text-soft);
  }
}

.dateSpan {
  text-align: end;
}
